<template>
<!-- Choose parameter and value form -->
<form
	v-if="step == 1 || (withPopUp && step == 2)"
	class="g-2 mt-0"
>
<fieldset
	class="row mx-0 my-0 py-0"
	:disabled="!isEnabled || !isSupportedPowerUnitVersion"
>
	<legend v-if="showTitle" class="col-12">
		<div class="text-center text-nowrap mb-2">Управління УКЗ</div>
	</legend>

	<div class="col-12 mb-2 mt-0">
		<label
			for="stabilization-parm"
			class="form-label mt-0 pt-0"
		>
			Параметр
		</label>
		<select
			class="form-select form-select-sm"
			id="stabilization-parm"
			v-model.lazy="parameter"
			@change="onChooseParameter"
			:disabled="isParameterDisabled"
			required
		>
			<option disabled value="">Оберіть параметр стабілізації</option>
			<option name="parameter" :value="STAB_PARMS.I.id">
				{{ capitalizeFirstLetter(STAB_PARMS.I.name) }}
			</option>
			<option name="parameter" :value="STAB_PARMS.E.id">
				{{ capitalizeFirstLetter(STAB_PARMS.E.name) }}
			</option>
			<option name="parameter" :value="STAB_PARMS.U.id">
				{{ capitalizeFirstLetter(STAB_PARMS.U.name) }}
			</option>
		</select>
		<div class="fst-italic" style="font-size: 0.875em;">
			Поточний параметр: <span class="fw-bold">
				{{ Object.values(STAB_PARMS)
					.find((el) => el.id == stationStabilizationValue(Station.passportKeys.stabilization.parameter))
					?.name
				}}
			</span>
		</div>
	</div>

	<div class="col-12 mb-2 mt-2">
		<label for="value" class="form-label">
			Значення&nbsp;&nbsp;&nbsp;<i><b>{{ rangeHint }}</b></i>
		</label>
		<input type="text"
			inputmode="numeric"
			aria-describedby="valueHelpBlock"
			step="0.1"
			class="form-control form-control-sm"
			name="value"
			id="value"
			v-model="value"
			@input="onValueInput"
			required
			:disabled="isValueDisabled"
		>
		<div class="fst-italic" style="font-size: 0.875em;">
			Поточне значення: <span class="fw-bold">
				{{ stationStabilizationValue(Station.passportKeys.stabilization.value) }}
			</span>
		</div>
		<div id="valueHelpBlock" class="form-text">
			<p :class="helpPromtClass">{{ helpPromt }}&nbsp;</p>
		</div>
	</div>

	<div class="col-12 mb-2 mt-2 d-grid gap-2 d-md-flex justify-content-md-center">
		<button
			type="button"
			class="btn btn-primary btn-sm"
			@click="onSubmit"
			:disabled="isSubmitDisabled"
		>
			<span
				v-if="isFetching"
				class="spinner-border spinner-border-sm"
				role="status"
				aria-hidden="true">
			</span>
			Встановити
		</button>
	</div>

	<div v-if="!isSupportedPowerUnitVersion"
		class="col-12 text-nowrap text-secondary my-0 py-0"
	>
		*&nbsp;Встановлений силовий модуль не може виконати цю дію
	</div>

	<!-- <input type="hidden" name="organization_name" value="ТестНазваОрганізації">
	<input type="hidden" name="org_id" value="ТестIDОрганізації">
	<input type="hidden" name="user_name" :value="userName"> -->
</fieldset>
</form>


<!-- Confirmation form -->
<div
	v-if="step == 2 && !withPopUp"
	class="container"
>
	<div class="row">
		<div class="col pb-3">
			<template v-if="isLoading">
				<span
					class="spinner-border spinner-border-sm"
					role="status"
					aria-hidden="true"
				>
				</span>
				Перевірка активних задач телекерування
			</template>
			<template v-else-if="isError">
				Помилка при перевірці активних задач телекерування, закрийте і спробуйте ще.
			</template>
			<template v-else-if="allRpcs.length > 0">
				Станція зараз обробляє інший запит
				("{{ rpcTaskSchema.job.findJob(allRpcs[0][rpcTaskSchema.job.key]).title }}").
				Будь ласка дочекайтесь його виконання.
			</template>
			<template v-else>
				Підтвердіть стабілізацію параметра <b>{{ parmSettings(parameter)?.name }}</b>
				на&nbsp;позначці&nbsp;<b>{{ value }}&nbsp;{{ parmSettings(parameter)?.unit }}</b>
			</template>
		</div>
	</div>
	<div class="row row-cols-2 justify-content-center">
		<div class="col-auto">
			<button
				class="btn btn-secondary btn-sm mx-2"
				style="min-width: 8em;"
				@click="step = 1"
			>
				{{ isLoading || isError || allRpcs.length > 0 ? 'Закрити' : 'Ні' }}
			</button>
		</div>
		<div class="col-auto">
			<button
				v-if="!isLoading && !isError && allRpcs.length == 0"
				class="btn btn-primary btn-sm mx-2"
				style="min-width: 8em;"
				@click="makeRequest()"
			>
				Так
			</button>
		</div>
	</div>
</div>


<!-- Modal for confirmation form -->
<confirmation-popup
	v-if="withPopUp"
	v-model:show="isPopupOpen"
	:confirm-button-title="isLoading || isError || allRpcs.length > 0 ? '' : 'Так'"
	:reject-button-title="isLoading || isError || allRpcs.length > 0 ? 'Закрити' : 'Ні'"
	@confirm="station.isActive ? makeRequest() : isPopupOpen = false"
>
	<template v-if="station.isActive" v-slot:body>
		<template v-if="isLoading">
			<span
				class="spinner-border spinner-border-sm"
				role="status"
				aria-hidden="true"
			>
			</span>
			Перевірка активних задач телекерування
		</template>
		<template v-else-if="isError">
			Помилка при перевірці активних задач телекерування, закрийте і спробуйте ще.
		</template>
		<template v-else>
			<template v-if="allRpcs.length > 0">
				Станція зараз обробляє інший запит
				("{{ rpcTaskSchema.job.findJob(allRpcs[0][rpcTaskSchema.job.key]).title }}").
				Будь ласка дочекайтесь його виконання.
			</template>
			<template v-else>
				Підтвердіть стабілізацію параметра <b>{{ parmSettings(parameter)?.name }}</b>
				на&nbsp;позначці&nbsp;<b>{{ value }}&nbsp;{{ parmSettings(parameter)?.unit }}</b>
			</template>
		</template>
	</template>
	<template v-else v-slot:body>
		Станція не активна. Тільки активні станції виконують запити.
	</template>
</confirmation-popup>
</template>




<script>
import ConfirmationPopup from "@/components/ConfirmationPopup.vue";
import { Station } from '@/models/station.js'
import { PowerUnit } from "@/models/powerUnit.js"
import { STAB_PARMS } from "@/app.conf"
import { parseTimeDate } from '@/api/api.js'
import { useAccontStore } from '@/stores/AccountStore'
import { useStationsStore } from '@/stores/StationsStore'
import {
	rpcTaskSchema,
	stationManageJobs,
	useRpcTasks,
} from '@/composables/rpcTasks.js'
import { capitalizeFirstLetter } from '@/helpers'

export default {
	components: {
		ConfirmationPopup,
	},

	props: {
		isEnabled: {
			type: Boolean,
			required: false,
			default: true,
		},
		stationId: {
			type: String,
			required: true,
			default: undefined,
		},
		showTitle: {
			type: Boolean,
			required: false,
			default: true,
		},
		/*
		Tehere is two scenarios of form visualization:
			1. With popup - form will be shown in the same window
				and confirmation popup will be shown
			2. Without popup - form will be shown in same window
				with confirmation popup (as next step)
		*/
		withPopUp: {
			type: Boolean,
			required: false,
			default: true,
		},
	},

	emits: {
		// Request creation result
		requestResult: value => typeof value === 'boolean',
		// Clear form method for externeal use
		clear: () => {
			return true
		},
	},

	setup() {
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()
		const {
			allRpcs,
			isLoading,
			isError,
			setFilters,
			createRpc,
		} = useRpcTasks()

		return {
			rpcTaskSchema,
			accountStore,
			stationsStore,
			Station,
			STAB_PARMS,

			allRpcs,
			isLoading,
			isError,
			setFilters,
			createRpc,
		}
	},

	data() {
		return {
			// Form step: 1 - choose parameter and value, 2 - confirm
			step: 1,

			// Selected stabilization parameter
			parameter: "",
			isParameterDisabled: false,

			// Value of stabilization
			value: null,
			isValueDisabled: true,

			// Help promt
			helpPromtClass: "text-secondary",
			helpPromt: "Спочатку оберіть параметр стабілізації",

			// Submit button
			isSubmitDisabled: true,
			isFetching: false,

			// Submit confirmation popup
			isPopupOpen: false,
		}
	},

	created() {
		// Return clear form method
		this.$emit('clear', () => {
			this.initForm()
		})
	},

	methods: {
		initForm() {
			this.step = 1
			this.parameter = ""
			this.isParameterDisabled = false,
			this.value = null
			this.isValueDisabled = true
			this.helpPromtClass = "text-secondary"
			this.helpPromt = "Спочатку оберіть параметр стабілізації"
			this.isSubmitDisabled = true
			this.isFetching = false
			this.isPopupOpen = false
		},

		onChooseParameter(/*parm*/) {
			//console.log("parameter = ", parm.target.value)
			this.isValueDisabled = false
			this.value = null
			this.printHint("")
		},

		onValueInput(value) {
			// If write only "-"
			if (value.target.value === "-") {
				return
			}

			// If write last character "," - replase to "."
			if (value.target.value.slice(-1) === ",") {
				this.value = value.target.value.slice(0, -1) + "."
				return
			}

			// If write sume not number characters - delete last character
			if (value.target.value.slice(-1) !== "." &&
				isNaN(Number(value.target.value))){
				this.value = value.target.value.slice(0, -1)
				return
			}

			// Normalization
			let val = this.normalizeInputValue (value.target.value)
			if (val === null) {
				this.printHint("")
				this.isSubmitDisabled = true
				return
			}

			// Validation
			switch(this.validateInputValue(val)) {
				case null:
					this.printErr("Невідомий параметр стабілізації")
					this.isSubmitDisabled = true
					break
				case true:
					this.printHint("")
					this.isSubmitDisabled = false
					break
				case false:
					this.printErr("Введене значення поза діапазоном")
					this.isSubmitDisabled = true
					break
			}
		},

		normalizeInputValue(input) {
			let norm

			if (String(input) == "") {
				this.printHint("")
				return null
			} else {
				norm = Number(input)
			}

			if (this.parameter == STAB_PARMS.E) {
				if (norm > 0) {
					norm *= -1
				}
			}

			return norm
		},

		validateInputValue (input) {
			const settings = this.parmSettings(this.parameter)

			// If no settigs for current parm
			if (settings === null) {
				return null
			}
			
			if (input < settings.min || input > settings.max) {
				return false
			}
			else {
				return true
			}

		},

		stationStabilizationValue(key) {
			if (!this.station.passport.has(Station.passportKeys.stabilization.self)) {
				return '-'
			}

			const stabilization = this.station.passport.get(Station.passportKeys.stabilization.self)

			if (key in stabilization) {
				if (key == Station.passportKeys.stabilization.updateTime) {
					return parseTimeDate(stabilization[key]).toLocaleString()
				} else {
					return stabilization[key]
				}
			} else {
				return "-"
			}
		},
		
		onSubmit () {
			this.checkActiveTask()
			this.step = 2

			if (this.withPopUp) {
				this.isPopupOpen = true
			} else {
				// this.step = 2
			}
		},

		checkActiveTask() {
			this.setFilters({
				destinationStationIds: this.stationId,
				isComplete: false,
				jobs: stationManageJobs,
			})
		},

		async makeRequest () {
			if (this.isLoading || this.isError || this.allRpcs.length > 0) {
				return
			}

			this.startLoadingAnimation()

			const result = await this.createRpc(
				this.accountStore.userId,
				rpcTaskSchema.job.allowed.updateStabilizationParms.key,
				this.stationId,
				null,
				{
					[rpcTaskSchema.context.parameter.key]: this.parameter,
					[rpcTaskSchema.context.value.key]: parseFloat(this.value),
				}
			)

			if (result) {
				this.printHint('Запит надіслано. Спостерігайте за його станом.')
			} else {
				this.printErr('Сталась помилка. Сервер відхилив запит.')
			}

			this.stopLoadingAnimation()
			this.step = 1
			this.$emit('requestResult', Boolean(result))
		},

		parmSettings(parmName) {
			// Search current parm settings
			let settings = null
			for(var key in STAB_PARMS) {
				if (STAB_PARMS[key].id == parmName) {
					settings = STAB_PARMS[key]
					break
				}
			}
			
			return settings
		},

		printHint (msg) {
			this.helpPromtClass = "text-secondary"
			this.helpPromt = msg
		},

		printErr (msg) {
			this.helpPromtClass = "text-danger"
			this.helpPromt = msg
		},

		startLoadingAnimation () {
			this.isParameterDisabled = true
			this.isSubmitDisabled = true
			this.isFetching = true
			this.isValueDisabled = true
		},

		stopLoadingAnimation () {
			this.isParameterDisabled = false
			this.isSubmitDisabled = false
			this.isFetching = false
			this.isValueDisabled = false
		},
	},

	computed: {
		station() { return this.stationsStore.station(this.stationId) },

		capitalizeFirstLetter() { return capitalizeFirstLetter },

		rangeHint () {
			// Text hint about allowed value range
			const settings = this.parmSettings(this.parameter)
			if (settings === null) {
				return ''
			}
			else {
				return `${settings.min}..${settings.max}`
			}
		},

		isSupportedPowerUnitVersion () {
			// If no power unit (undefined)
			if (!this.station.passport.has(Station.passportKeys.powerUnit.self)) {
				return false
			}

			return [
				PowerUnit.versions.v2017,
				PowerUnit.versions.v2022,
				PowerUnit.versions.v2025,
				PowerUnit.versions.v2025t,
				PowerUnit.versions.mcps,
			].includes(this.station.passport.get(Station.passportKeys.powerUnit.self)[Station.passportKeys.powerUnit.unitVersion])
		},
	},
}
</script>


<style src="@/assets/stationForm.css" scoped></style>